import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Building2, CheckCircle, BarChart3, Shield, Users, Globe } from 'lucide-react';

export default function ForMutuellesPage() {
  return (
    <div className="min-h-screen py-24 md:py-32 bg-background" data-testid="for-mutuelles-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-medium tracking-wider uppercase text-primary mb-3 block">Partenariats B2B</span>
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Mutuelles, CSE & collectivités
          </h1>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Proposez des solutions de répit innovantes et adaptées à vos adhérents, salariés aidants ou administrés.
          </p>
        </div>

        <div className="bg-primary text-primary-foreground rounded-3xl p-8 md:p-12 mb-12">
          <h2 className="font-heading text-2xl font-semibold mb-4">Un enjeu majeur de société</h2>
          <p className="text-primary-foreground/80 leading-relaxed mb-6">
            En France, 11 millions de personnes accompagnent au quotidien un proche en perte d'autonomie. Parmi les salariés aidants, beaucoup sont en situation d'épuisement. Proposer des solutions de répit adaptées, c'est agir concrètement pour le bien-être de vos populations.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { value: "11M", label: "aidants en France" },
              { value: "1/2", label: "renoncent aux vacances" },
              { value: "60%", label: "sont salariés" },
              { value: "47%", label: "se sentent isolés" }
            ].map(({ value, label }) => (
              <div key={label} className="text-center p-4 rounded-xl bg-white/5">
                <p className="font-heading text-2xl font-bold text-accent">{value}</p>
                <p className="text-xs text-primary-foreground/60 mt-1">{label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {[
            { icon: Building2, title: "Programme dédié", desc: "Des offres de séjours de répit sur mesure pour vos populations : adhérents, salariés, administrés." },
            { icon: BarChart3, title: "Reporting", desc: "Un suivi d'indicateurs pour mesurer l'impact de votre engagement : nombre de bénéficiaires, satisfaction, zones couvertes." },
            { icon: Shield, title: "Conformité", desc: "Un cadre rigoureux de traitement des données et de respect de la confidentialité." }
          ].map(({ icon: Icon, title, desc }) => (
            <div key={title} className="bg-white rounded-2xl p-6 border border-border/30 shadow-sm hover:shadow-md transition-all">
              <Icon className="w-8 h-8 text-primary mb-4" />
              <h3 className="font-heading text-base font-semibold mb-2">{title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/contact">
            <Button className="rounded-full bg-primary text-primary-foreground px-8 py-6 text-lg font-semibold hover:bg-primary/90 shadow-lg hover:scale-105 transition-all" data-testid="mutuelles-cta">
              Discuter d'un partenariat <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
